<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@200&display=swap");

.custom-values-form{
  font-family: Roboto, system, -apple-system !important;
  font-family: var(--customization_font_family)!important;
}
/* width */
.explanation::-webkit-scrollbar {
  width: 2px;
}

/* Track */
.explanation::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.explanation::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
.explanation::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.explanation {
  max-height: 200px;
  overflow-y: scroll;
  padding-right: 10px;
}

[speech-bubble] {
  --bbColor: grey;
  --bbArrowSize: 1.5rem;
  --bbBorderRadius: 0.25rem;
  --bbPadding: 1rem;
  background: var(--bbColor);
  border-radius: var(--bbBorderRadius);
  padding: var(--bbPadding);
  z-index: 100;
  position: absolute;
  top: 30px;
  right: 35px;
  transform: scale(0);
  animation-fill-mode: forwards;
  max-width: 65vw;

}

[speech-bubble]::before {
  content: '';
  position: absolute;
  background: var(--bbColor);
}

[speech-bubble][pbottom] {
  margin-bottom: var(--bbArrowSize)
}

[speech-bubble][ptop] {
  margin-top: var(--bbArrowSize);
}

[speech-bubble][pleft] {
  margin-left: var(--bbArrowSize);
}

[speech-bubble][pright] {
  margin-right: var(--bbArrowSize);
}


/* bottom and top  */
[speech-bubble][pbottom]::before,
[speech-bubble][ptop]::before {
  --width: calc(var(--bbArrowSize) / 2 * 3);
  height: var(--bbArrowSize);
  width: var(--width);
}

/* bottom */
[speech-bubble][pbottom]::before {
  top: calc(100% - 2px);
}

[speech-bubble][pbottom][aleft]::before {
  left: 1rem;
  clip-path: polygon(25% 0, 100% 0, 0% 100%)
}

[speech-bubble][pbottom][acenter]::before {
  left: calc(50% - var(--width) / 2);
  clip-path: polygon(12.5% 0, 87.5% 0, 50% 100%)
}

[speech-bubble][pbottom][aright]::before {
  right: 1rem;
  clip-path: polygon(0 0, 75% 0, 100% 100%)
}

/* top */
[speech-bubble][ptop]::before {
  bottom: calc(100% - 2px);
}

[speech-bubble][ptop][aleft]::before {
  left: var(--bbPadding);
  clip-path: polygon(0 0, 100% 100%, 25% 100%)
}

[speech-bubble][ptop][acenter]::before {
  left: calc(50% - var(--width) / 2);
  clip-path: polygon(12.5% 100%, 50% 0, 87.5% 100%)
}

[speech-bubble][ptop][aright]::before {
  right: var(--bbPadding);
  clip-path: polygon(0 100%, 100% 0, 75% 100%)
}

/* left and right  */
[speech-bubble][pleft]::before,
[speech-bubble][pright]::before {
  --height: calc(var(--bbArrowSize) / 2 * 3);
  width: var(--bbArrowSize);
  height: var(--height);
}

/* right */
[speech-bubble][pright]::before {
  left: calc(100% - 2px);
}

[speech-bubble][pright][atop]::before {
  top: var(--bbPadding);
  clip-path: polygon(100% 0, 0 100%, 0 25%)
}

[speech-bubble][pright][acenter]::before {
  top: calc(50% - var(--height) / 2);
  clip-path: polygon(0 12.5%, 100% 50%, 0 87.5%)
}

[speech-bubble][pright][abottom]::before {
  bottom: var(--bbPadding);
  clip-path: polygon(0 0, 100% 100%, 0 75%)
}

/* left */
[speech-bubble][pleft]::before {
  right: calc(100% - 2px);
}

[speech-bubble][pleft][atop]::before {
  top: var(--bbPadding);
  clip-path: polygon(0 0, 100% 25%, 100% 100%)
}

[speech-bubble][pleft][acenter]::before {
  top: calc(50% - var(--height) / 2);
  clip-path: polygon(0 50%, 100% 12.5%, 100% 87.5%);
}

[speech-bubble][pleft][abottom]::before {
  bottom: var(--bbPadding);
  clip-path: polygon(0 100%, 100% 0, 100% 75%)
}

/* flip */
[speech-bubble][pbottom][flip]::before,
[speech-bubble][ptop][flip]::before {
  transform: scaleX(-1)
}

[speech-bubble][pleft][flip]::before,
[speech-bubble][pright][flip]::before {
  transform: scaleY(-1)
}


@keyframes expand-bounce {
  0% {
    transform: scale(0);
  }

  50% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
}

/* Here the scale simply goes from 1 back to 0 */
@keyframes shrink {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(0);
  }
}



/*Dialog Styles*/
dialog {
  padding: 1rem 3rem;
  background: white;
  max-width: 800px;
  padding-top: 2rem;
  border-radius: 20px;
  border: 0;
  box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.1);
  -webkit-animation: fadeIn 1s ease both;
  animation: fadeIn 1s ease both;
}

dialog::-webkit-backdrop {
  -webkit-animation: fadeIn 1s ease both;
  animation: fadeIn 1s ease both;
  background: rgba(255, 255, 255, 0.4);
  z-index: 2;
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
}

dialog::backdrop {
  -webkit-animation: fadeIn 1s ease both;
  animation: fadeIn 1s ease both;
  background: rgba(255, 255, 255, 0.4);
  z-index: 2;
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
}

dialog .x {
  filter: grayscale(1);
  border: none;
  outline: none;
  background: none;
  position: absolute;
  top: 15px;
  right: 10px;
  transition: ease filter, transform 0.3s;
  cursor: pointer;
  transform-origin: center;
}

dialog .x:hover {
  filter: grayscale(0);
  transform: scale(1.1);
}

dialog h2 {
  font-weight: 600;
  font-size: 1.5rem;
  padding-bottom: 1rem;
}

dialog p {
  font-size: 1rem;
  line-height: 1.3rem;
  padding: 0.5rem 0;
}

dialog p a:visited {
  color: rgb(var(--vs-primary));
}

/*General Styles*/

@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}


.container {
  display: flex;
  align-items: center;
}

.container .card {
  /* height: 500px; */
  position: relative;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  font-family: Roboto, system, -apple-system !important;
  font-family: var(--customization_font_family)!important;
  border-radius: 20px;
}

.container .card .formulaire {
  height: 100%;
}

.container .card .left-side {
  background-color: #304767;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  padding: 20px 30px;
  box-sizing: border-box;
}

/*left-side-start*/
.steps-content {
  margin-top: 30px;
  color: var(--customization_custom_color);
}

.steps-content p {
  font-size: 12px;
  margin-top: 15px;
}

.progress_bar {
  list-style: none;
  /*color:#fff;*/
  font-size: 13px;
  font-weight: 700;
  counter-reset: container 0;
}

.progress_bar li {
  position: relative;
  margin-top: 50px;
  counter-increment: container 1;
  color: #4f6581;
  cursor: pointer;

  transition: all 0.4s ease-in-out;
}

.progress_bar li::before {
  content: counter(container);
  line-height: 25px;
  text-align: center;
  position: absolute;
  height: 25px;
  width: 25px;
  border: 1px solid #4f6581;
  border-radius: 50%;
  left: -40px;
  top: -5px;
  z-index: 10;
  background-color: var(--customization_custom_background);
  transition: all 0.4s ease-in-out;
}

.progress_bar li::after {
  content: "";
  position: absolute;
  height: 90px;
  width: 2px;
  background-color: #4f6581;
  z-index: 1;
  left: -27px;
  top: -70px;
  transition: all 0.4s ease-in-out;
}

.progress_bar li.active::after {
  background-color: var(--customization_custom_color);
  transition: all 0.4s ease-in-out;
}

.progress_bar li:first-child:after {
  display: none;
}

.progress_bar li.active::before {
  color: var(--customization_custom_color);
  border: 1px solid var(--customization_custom_color);
  transition: all 0.4s ease-in-out;
}

.progress_bar li.active {
  color: var(--customization_custom_color);
  transition: all 0.4s ease-in-out;
}

.d-none {
  display: none;
}

/*left-side-end*/
.container .card .right-side {
  height: 100%;
  border-radius: 20px;
}

/*right-side-start*/
.main {
  display: none;
}

.active {
  display: block;
}

.text {
  margin-top: 20px;
}

.congrats {
  text-align: center;
}

.text p {
  margin-top: 10px;
  font-size: 13px;
  font-weight: 700;
  color: #cbced4;
}

.input-text {
  margin: 30px 0;
  display: flex;
}

.input-text .input-div {
  width: 100%;
  position: relative;

}



input {
  width: 100%;
  height: 40px;
  border: none;
  outline: 0 !important;
  border: 1px solid #cbced4;
  border-radius: 0px !important;
}

select,
textarea {
  width: 100%;
  height: 40px;
  border: none;
  outline: 0 !important;
  border-radius: 5px;
  border: 1px solid #cbced4;
  box-sizing: border-box;
  padding: 0px 10px;
  border-radius: 0px !important;
}

.input-text .input-div span {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 14px;
  transition: all 0.5s;
}

.input-div input:focus~span,
.input-div input:valid~span {
  top: -15px;
  left: 6px;
  font-size: 10px;
  font-weight: 600;
}

.input-div span {
  top: -15px;
  left: 6px;
  font-size: 10px;
}

/* .buttons button {
  height: 40px;
  width: 100px;
  border: none;
  border-radius: 5px;
  background-color: #0075ff;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
} */
.button_space {
  display: flex;
}

.button_space button:nth-child(1) {
  background-color: #fff;
  color: #000;
  border: 1px solid#000;
}

@keyframes stroke {
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes scale {

  0%,
  100% {
    transform: none;
  }

  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
}

@keyframes fill {
  100% {
    box-shadow: inset 0px 0px 0px 30px #7ac142;
  }
}

label {
  text-transform: capitalize;
  font-family: var(--customization_label_font_family);
  color: black !important; 
  color: var(--customization_label_color) !important;
}

.radio .radio-tooltip {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50% !important;
  width: 25px !important;
  height: 25px !important;
  font-size: 12px !important;
}

.tooltip-button {
  border: 1px solid #cbced4;
  background: transparent;
  border-radius: 0px !important;
}

.input,
.file,
.select,
.textarea {
  display: flex;
}

.form_color {
  display: inline;
  height: 40px;
  max-width: 100px;
  border: 1px solid gray;
}

.text-muted {
  font-size: 10px;
}

textarea,
select,
textarea:focus,
textarea:hover {
  outline: 0;
  border: 1px solid #d4dfe4;
}

.warning {
  border: 1px solid red !important;
}

.slideDown {
  position: relative;
  animation: slideDown ease-in-out 0.4s;
}

@keyframes slideDown {
  0% {
    top: -25px;
    opacity: 0;
  }

  100% {
    top: 0px;
    opacity: 1;
  }
}

.textarea_height, textarea{
  height: 200px !important;
  background-color: red !important;
}
</style>

<template>
  <div v-if="pages.length > 0" class="container p-0 py-4 custom-values-form">
    <app-overlay-loader v-if="preloader" />
    <div class="card container-fluid" 
      :style="{ 
        '--customization_custom_background': customization.custom_background , 
        '--customization_custom_color': customization.custom_color,
        '--customization_font_family': customization.font_family,
        '--customization_label_font_family': customization.label_font_family,
        '--customization_label_color': customization.label_color,
        '--customization_button_border_color': customization.button_border_color,
        '--customization_button_border': customization.button_border,
      }">
      <div class="formulaire row">
        <div class="left-side col-lg-3 d-none d-md-block" :style="{ backgroundColor: customization.custom_background }">
          <div class="steps-content">
            <h4 :style="{color: customization.custom_color }" class="">Step <span class="step-number">1</span></h4>
          </div>
          <ul class="progress_bar">
            <li @click="showTab(index)" class="" v-for="(page, index) in pages" :key="'step_' + index"
              :class="formnumber >= index ? 'active' : ''">
              {{ replaceFieldKeysWithValues(page.name )}}
            </li>
          </ul>
        </div>

        <div class="right-side col-lg-9 pb-3">
          <div class="main  slideDown" v-for="(page, index) in pages" :key="'page_' + index"
            :class="formnumber >= index ? 'active' : ''">
            <div class="text text-center">
              <h4 class="d-none d-md-block">{{ replaceFieldKeysWithValues(formname) }}</h4>
              <h4 class="d-block d-md-none">{{ index }}. {{ replaceFieldKeysWithValues(formname) }}</h4>
              <p>{{ replaceFieldKeysWithValues(page.name) }}.</p>
              <div class="mt-4 mb-5" v-html="replaceFieldKeysWithValues(page.step_description)"></div>
            </div>


            <div v-if="page.custom_values.length <= 0" class="w-100 text-center mt-4 pt-4 mb-4 pb-4">
              <h3 class="text-center text-warning mt-4 pt-4 mb-4 pb-4">
                {{ emptyStateConfig.message }}
              </h3>
              <div v-if="emptyStateConfig.purchase_url" class="mt-2">
                <a :href="emptyStateConfig.purchase_url" target="_blank" rel="noopener" class="btn" :style="{ backgroundColor: customization.button_background, color: customization.button_color, borderColor: customization.button_border_color, borderWidth: customization.button_border + 'px' }">
                  {{ emptyStateConfig.link_text }}
                </a>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12" v-for="(custom_value, val_index) in   Object.values(page.custom_values)"
                :key="custom_value.id">
                <!--select-->
                <div v-if="'select' ===
                  custom_value_type(custom_value.custom_field_type_id)
                  ">
                  <label for="" class="d-block">{{
                    custom_value.field_name
                  }}</label>
                  <p class="select">
                    <select class="" oninput='this.classList.remove("invalid")'
                      :class="{ required: custom_value.required }" :name="custom_value.field_name"
                      :ref="custom_value.field_name" v-model="field_values[index][val_index].value" @change="setCustomValue(
                        field_values[index][val_index].value,
                        custom_value
                      )
                        ">
                      <option disabled :value="''" selected="selected">
                        Please select an option
                      </option>
                      <option v-for="element in custom_value.choices.split(';')" :key="element" :value="element">
                        {{ element }}
                      </option>
                    </select>

                    <button :id="'parent' + index + val_index" type="button"
                      @click="showToolTip('#SpeechBubble' + index + val_index)" class="shadow-sm">
                      <i class="fas fa-info"></i>
                    </button>

                  <div class="SpeechBubble" speech-bubble pright atop style="--bbColor:#929292"
                    :id="'SpeechBubble' + index + val_index">
                    <div class="explanation"><span v-html="custom_value.description ?? custom_value.field_name"></span>
                    </div>
                  </div>
                  </p>
                </div>

                <!--multi-select-->
                <div v-if="'multi-select' ===
                  custom_value_type(custom_value.custom_field_type_id)
                  ">
                  <label for="" class="d-block">{{
                    custom_value.field_name
                  }}</label>

                  <p class="select">
                    <multiselect :name="custom_value.field_name" :ref="custom_value.field_name" :multiple="true"
                     :clear-on-select="false" :preserve-search="true" placeholder="Please select option"
                      v-model="field_values[index][val_index].value" @input="setCustomValue(
                        field_values[index][val_index].value,
                        custom_value
                      )
                        " :preselect-first="false" :close-on-select="false"
                      :options="custom_value.choices.split(';')">
                      <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single"
                          v-if="values.length > 0 && !isOpen">{{ values.length }} options selected</span></template>
                    </multiselect>

                    <button :id="'parent' + index + val_index" type="button"
                      @click="showToolTip('#SpeechBubble' + index + val_index)" class="shadow-sm">
                      <i class="fas fa-info"></i>
                    </button>

                  <div class="SpeechBubble" speech-bubble pright atop style="--bbColor:#929292"
                    :id="'SpeechBubble' + index + val_index">
                    <div class="explanation"><span v-html="custom_value.description ?? custom_value.field_name"></span>
                    </div>
                  </div>
                  </p>
                </div>

                <!--text-->
                <div v-if="['text', 'number', 'password', 'date'].includes(
                  custom_value_type(custom_value.custom_field_type_id)
                )
                  " class="mb-2">
                  <label for="" class="d-block">{{
                    custom_value.field_name
                  }}</label>

                  <p class="input">
                    <span class="input-group-prepend" v-if="custom_value.prefix">
                      <span class="input-group-text" style="height: 40px;" id="basic-addon1">{{ custom_value.prefix }}</span>
                    </span>
                    <input class="shadow-sm " :class="{ required: custom_value.required }"
                    :required="custom_value.required" 
                      v-if="hasOperation(custom_value.fieldKey, custom_value.field_key)"
                      :type="custom_value_type(custom_value.custom_field_type_id)" :placeholder="custom_value.field_name"
                      :readonly="true" :ref="custom_value.field_name" :name="custom_value.field_name" @change="setCustomValue(
                        getFieldOperationValue(
                          operations_values[custom_value.field_key].operand1,
                          operations_values[custom_value.field_key].operand2,
                          operations_values[custom_value.field_key].operator,
                          operations_values[custom_value.field_key].type
                        ),
                        custom_value
                      )
                        " :value="getFieldOperationValue(
    operations_values[custom_value.field_key].operand1,
    operations_values[custom_value.field_key].operand2,
    operations_values[custom_value.field_key].operator,
    operations_values[custom_value.field_key].type
  )
    " oninput='this.classList.remove("invalid")' />

                    <input class="shadow-sm form-control" :class="{ required: custom_value.required }" v-else
                    :required="custom_value.required"
                      :type="custom_value_type(custom_value.custom_field_type_id)" :placeholder="custom_value.field_name"
                      :ref="custom_value.field_name" :name="custom_value.field_name"
                      v-model="field_values[index][val_index].value" @change="setCustomValue(
                        field_values[index][val_index].value,
                        custom_value
                      )
                        " oninput='this.classList.remove("invalid")' />
                    <span class="input-group-append" v-if="custom_value.suffix">
                      <span class="input-group-text" id="basic-addon2" style="height: 40px;">{{ custom_value.suffix }}</span>
                    </span>
                    <button :id="'parent' + index + val_index" type="button"
                      @click="showToolTip('#SpeechBubble' + index + val_index)" class="shadow-sm">
                      <i class="fas fa-info"></i>
                    </button>

                  <div class="SpeechBubble" speech-bubble pright atop style="--bbColor:#929292"
                    :id="'SpeechBubble' + index + val_index">
                    <div class="explanation"><span v-html="custom_value.description ?? custom_value.field_name"></span>
                    </div>
                  </div>
                  </p>
                </div>

                <!--color picker-->
                <div v-if="'Color picker' ===
                  custom_value_type(custom_value.custom_field_type_id)
                  ">
                  <div class="mb-4">
                    <label class="d-block">
                      {{ custom_value.field_name }}
                    </label>
                    <div class="d-flex" v-if="hasOperation(custom_value.fieldKey, custom_value.field_key)">
                      <input type="color" disabled required require class="form_color" :readonly="true" :ref="custom_value.field_name" :name="custom_value.field_name"
                    @change="setCustomValue(
                          getFieldOperationValue(
                            operations_values[custom_value.field_key].operand1,
                            operations_values[custom_value.field_key].operand2,
                            operations_values[custom_value.field_key].operator,
                            operations_values[custom_value.field_key].type
                          ),
                          custom_value
                        )
                        " :value="getFieldOperationValue(
          operations_values[custom_value.field_key].operand1,
          operations_values[custom_value.field_key].operand2,
          operations_values[custom_value.field_key].operator,
          operations_values[custom_value.field_key].type
        )
        " />
                      <input type="text" disabled required require class="form_color ml-4" :readonly="true" :ref="custom_value.field_name" :name="custom_value.field_name"
                    @change="setCustomValue(
                          getFieldOperationValue(
                            operations_values[custom_value.field_key].operand1,
                            operations_values[custom_value.field_key].operand2,
                            operations_values[custom_value.field_key].operator,
                            operations_values[custom_value.field_key].type
                          ),
                          custom_value
                        )
                        " :value="getFieldOperationValue(
          operations_values[custom_value.field_key].operand1,
          operations_values[custom_value.field_key].operand2,
          operations_values[custom_value.field_key].operator,
          operations_values[custom_value.field_key].type
        )
        " />

                    </div>
                    <div class="d-flex" v-else>
                      <input type="color" required require class="form_color" v-model="field_values[index][val_index].value" @input="setCustomValue(
                          field_values[index][val_index].value,
                          custom_value
                        )
                        "  />
                      <input type="text" required require class="form_color ml-4" v-model="field_values[index][val_index].value" @input="setCustomValue(
                          field_values[index][val_index].value,
                          custom_value
                        )
                        "  />

                    </div>
                  </div>
                </div>

                <!--file-->
                <div class="mb-4" v-if="'File' ===
                  custom_value_type(custom_value.custom_field_type_id)
                  ">
                  <File :custom_value="custom_value" :ref="'file_' + custom_value.id" />
                </div>

                <!--textarea-->
                <div v-if="'textarea' ==
                custom_value_type(custom_value.custom_field_type_id)
                " class="mb-2">
                <label for="" class="d-block">{{
                  custom_value.field_name
                }}</label>

                <p class="textarea">
                    <app-input 
                    v-if="hasOperation(custom_value.fieldKey, custom_value.field_key)" 
                        custom-config
                        type="textarea"
                        class="shadow-sm w-100"
                        :removeClass="true"
                        inputClass="textarea_height"
                        :id="'textarea-id' + index + val_index"
                        :label="custom_value.field_name"
                        :class="{ required: custom_value.required }"
                        :name="custom_value.field_name" 
                        :ref="custom_value.field_name"
                        
                        @input="setCustomValue(
                          getFieldOperationValue(
                            operations_values[custom_value.field_key].operand1,
                            operations_values[custom_value.field_key].operand2,
                            operations_values[custom_value.field_key].operator,
                            operations_values[custom_value.field_key].type
                          ),
                          custom_value
                        )
                        " :value="getFieldOperationValue(
                            operations_values[custom_value.field_key].operand1,
                            operations_values[custom_value.field_key].operand2,
                            operations_values[custom_value.field_key].operator,
                            operations_values[custom_value.field_key].type
                          )"
                        oninput='this.classList.remove("invalid")'
                        :placeholder="custom_value.field_name" 
                      />

                      <app-input v-else
                        custom-config
                        type="textarea"
                        class="shadow-sm w-100 " 
                        :removeClass="true"
                        inputClass="textarea_height"
                        :id="'textarea-id' + index + val_index"
                        :label="custom_value.field_name"
                        :class="{ required: custom_value.required }"
                        :name="custom_value.field_name" 
                        :ref="custom_value.field_name"
                        v-model="field_values[index][val_index].value"
                        @input="setCustomValue(
                          field_values[index][val_index].value,
                          custom_value
                        )
                        " 
                        oninput='this.classList.remove("invalid")'
                        :placeholder="custom_value.field_name" 
                      />

                      <button :id="'parent' + index + val_index" type="button"
                      @click="showToolTip('#SpeechBubble' + index + val_index)" class="shadow-sm">
                      <i class="fas fa-info"></i>
                    </button>

                  <div class="SpeechBubble" speech-bubble pright atop style="--bbColor:#929292"
                    :id="'SpeechBubble' + index + val_index">
                    <div class="explanation"><span v-html="custom_value.description ?? custom_value.field_name"></span>
                    </div>
                    </div>
                </p>

              </div>

              <!--text editor-->
              <div v-if="'text-editor' ==
                custom_value_type(custom_value.custom_field_type_id)
                " class="mb-2">
                <label for="" class="d-block">{{
                  custom_value.field_name
                }}</label>

                <p class="textarea">
                    <app-input 
                    v-if="hasOperation(custom_value.fieldKey, custom_value.field_key)" 
                        custom-config
                        type="text-editor"
                        class="shadow-sm w-100"
                        :id="'text-editor-id' + index + val_index"
                        :key="'text-editor-id' + index + val_index"
                        :label="custom_value.field_name"
                        :class="{ required: custom_value.required }"
                        :name="custom_value.field_name" 
                        :ref="custom_value.field_name"
                        
                        @input="setCustomValue(
                          getFieldOperationValue(
                            operations_values[custom_value.field_key].operand1,
                            operations_values[custom_value.field_key].operand2,
                            operations_values[custom_value.field_key].operator,
                            operations_values[custom_value.field_key].type
                          ),
                          custom_value
                        )
                        " :value="getFieldOperationValue(
                            operations_values[custom_value.field_key].operand1,
                            operations_values[custom_value.field_key].operand2,
                            operations_values[custom_value.field_key].operator,
                            operations_values[custom_value.field_key].type
                          )"
                        oninput='this.classList.remove("invalid")'
                        :placeholder="custom_value.field_name" 
                      />

                      <app-input v-else
                        custom-config
                        type="text-editor"
                        class="shadow-sm w-100 " 
                        :id="'text-editor-id' + index + val_index"
                        :label="custom_value.field_name"
                        :class="{ required: custom_value.required }"
                        :name="custom_value.field_name" 
                        :ref="custom_value.field_name"
                        v-model="field_values[index][val_index].value"
                        @input="setCustomValue(
                          field_values[index][val_index].value,
                          custom_value
                        )
                        " 
                        oninput='this.classList.remove("invalid")'
                        :placeholder="custom_value.field_name" 
                        :key="'text-editor-id' + index + val_index"
                      />

                      <button :id="'parent' + index + val_index" type="button"
                      @click="showToolTip('#SpeechBubble' + index + val_index)" class="shadow-sm">
                      <i class="fas fa-info"></i>
                    </button>

                  <div class="SpeechBubble" speech-bubble pright atop style="--bbColor:#929292"
                    :id="'SpeechBubble' + index + val_index">
                    <div class="explanation"><span v-html="custom_value.description ?? custom_value.field_name"></span>
                    </div>
                    </div>
                </p>

              </div>
              
                <!--radio-->
                <div v-if="'radio' ===
                  custom_value_type(custom_value.custom_field_type_id)
                  ">
                  <label for="" class="d-block">{{
                    custom_value.field_name
                  }}</label>

                  <p class="radio">

                  <div class="form-check form-check-inline"
                    v-for='(item, item_index) in (custom_value.choices.split(";"))'>
                    <input class="form-check-input" oninput='this.classList.remove("invalid")'
                      :class="{ required: custom_value.required }" :ref="custom_value.field_name"
                      :name="custom_value.field_name" v-model="field_values[index][val_index].value" @change="setCustomValue(
                        field_values[index][val_index].value,
                        custom_value
                      )
                        " type="radio" :id="'inlineRadio' + item_index" :value="item">
                    <label class="form-check-label" :for="'inlineRadio' + item_index"> {{ item }}</label>
                  </div>

                  <button :id="'parent' + index + val_index" type="button"
                    @click="showToolTip('#SpeechBubble' + index + val_index)" class="shadow-sm">
                    <i class="fas fa-info"></i>
                  </button>

                  <div class="SpeechBubble" speech-bubble pright atop style="--bbColor:#929292"
                    :id="'SpeechBubble' + index + val_index">
                    <div class="explanation"><span v-html="custom_value.description ?? custom_value.field_name"></span>
                    </div>
                  </div>
                  </p>
                </div>

                <!--checkbox-->
                <div v-if="'checkbox' ===
                  custom_value_type(custom_value.custom_field_type_id)
                  ">
                  <label for="" class="d-block">{{
                    custom_value.field_name
                  }}</label>

                  <p class="checkbox">
                  <div class="form-check form-check-inline" v-if="custom_value.choices.includes('#single:')">
                    <input class="form-check-input mt-4" id="checkbox-1" oninput='this.classList.remove("invalid")'
                      :class="{ required: custom_value.required }" :ref="custom_value.field_name"
                      v-model="field_values[index][val_index].value" @change="setCustomValue(
                        field_values[index][val_index].value,
                        custom_value
                      )
                        " :value="custom_value.choices
    .replace(/#multiple:|#single:/gi, '')
    .split(';')[0]
    " :unchecked-value="custom_value.choices
    .replace(/#multiple:|#single:/gi, '')
    .split(';')[1]
    " type="checkbox">
                    <label class="form-check-label" for="inlineCheckbox1">{{ custom_value.field_name }}</label>
                  </div>

                  <div class="form-check form-check-inline" v-if="custom_value.choices.includes('#multiple:')"
                    v-for='(item, item_index) in custom_value.choices.replace(/#multiple:|#single:/gi, "").split(";")'>
                    <input class="form-check-input mt-4" :id="item" :class="{ required: custom_value.required }"
                     :ref="custom_value.field_name" v-model="field_values[index][val_index].value" @change="setCustomValue(
                        field_values[index][val_index].value,
                        custom_value
                      )
                        " oninput='this.classList.remove("invalid")' type="checkbox" :value="item">
                    <label class="form-check-label" for="'item'">{{ item }}</label>
                  </div>

                  <button :id="'parent' + index + val_index" type="button"
                    @click="showToolTip('#SpeechBubble' + index + val_index)" class="shadow-sm">

                    <i class="fas fa-info"></i>
                  </button>

                  <div class="SpeechBubble" speech-bubble pright atop style="--bbColor:#929292"
                    :id="'SpeechBubble' + index + val_index">
                    <div class="explanation"><span v-html="custom_value.description ?? custom_value.field_name"></span>
                    </div>
                  </div>
                  </p>
                </div>
              </div>
            </div>

            <div class="buttons d-flex mt-5">
              <button 
                :style="{ 
                  backgroundColor: customization.button_background, 
                  color: customization.button_color ,
                  borderColor: customization.button_border_color,
                  borderWidth: customization.button_border+'px'
                }" 
                class="back_button mr-4 btn btn-outline" :disabled="preloader || filePreloader"
                v-if="index > 0">
                Back
              </button>
              <div>
                <button 
                  :style="{ 
                    backgroundColor: customization.button_background, 
                    color: customization.button_color ,
                    borderColor: customization.button_border_color,
                    borderWidth: customization.button_border+'px'
                  }" 
                 v-if="index < pages.length - 1" class="next_button btn"
                  :disabled="preloader || filePreloader">
                  Save
                </button>

                <button 
                  :style="{ 
                    backgroundColor: customization.button_background, 
                    color: customization.button_color ,
                    borderColor: customization.button_border_color,
                    borderWidth: customization.button_border+'px'
                  }" 
                  class="next_button btn" :disabled="preloader || filePreloader">
                  <span v-if="index < pages.length - 1"> Next Step</span>
                  <span v-else>Save</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <dialog id="dialog">
      <h2>{{ modalName }}</h2>
      <p>{{ modalDescription }}</p>
      <button @click="HideToolTip" aria-label="close" class="x">❌</button>
    </dialog>
  </div>
  <div v-else class="w-100 text-center mt-4 pt-4">
    <h1 class="text-warning text-center mt-4 pt-4">
      You need to add pages and customs values on your application.
    </h1>
    <a :href="urlGenerator('app/custom')" type="button" class="btn btn-primary btn-with-shadow mt-4">
      custom values
    </a>
  </div>
</template>
<script>
import { urlGenerator } from "../../../Helpers/AxiosHelper";
import Verte from 'verte';
import coreLibrary from "../../../../core/helpers/CoreLibrary";
import 'verte/dist/verte.css';
import Multiselect from "vue-multiselect";
import FirstInput from "./components/FirstInput.vue";
import { FormMixin } from "../../../../core/mixins/form/FormMixin";

import File from "./components/file.vue";
export default {
  mixins: [FormMixin],
  props: [
    "pages",
    "custom_field_types",
    "operations",
    "action",
    "customization",
    "originalCustomValues",
    "formname",
    "emptyStateConfig",
  ],
  components: { Multiselect, verte: Verte, FirstInput, File },

  data() {
    return {
      modalName: "",
      modalDescription: "",
      name: "TextArea",
      next_click: [],
      main_form: [],
      step_list: [],
      num: [],
      formnumber: 0,
      validate_inputs: [],
      validate_textarea: [],
      nb: 5,



      urlGenerator,
      preloader: false,
      filePreloader: false,
      field_values: [],
      operations_values: [],
      operations_index: [],
      field_index: [],
      page_index: [],
      customValues: [],

      fieldValueMap: new Map(),
      testFieldValueMap: new Map()

    };
  },


  created() {
    this.reorderPage();

    this.pages.forEach((page, page_index) => {
      let data = [];
      //page.custom_values.sort(this.compare);
      Object.values(page.custom_values).forEach((custom_value, index) => {
        if (custom_value.choices == null || custom_value.choices == "") {
          if (custom_value.value == null || custom_value.value == "") {
            data.push({ value: custom_value.default_value ?? "" });
            custom_value.value = custom_value.default_value ?? "";
          } else {
            if (
              typeof custom_value.value == "number" ||
              typeof custom_value.value == "string"
            ) {
              data.push({ value: this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, custom_value.value ?? "") });
            } else {
              data.push({ value: custom_value.default_value ?? "" });
              custom_value.value = custom_value.default_value ?? "";
            }
          }
        } else {
          if (custom_value.choices.split(";").includes(custom_value.value)) {
            if (
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "checkbox" ||
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "multi-select"
            ) {
              if (custom_value.choices.includes("#single:")) {
                data.push({
                  value: custom_value.value,
                });
              } else {
                data.push({ value: custom_value.value.split(";") });
              }
            } else {
              data.push({ value: custom_value.value });
            }
          } else {
            if (
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "checkbox" ||
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "multi-select"
            ) {
              if (custom_value.choices.includes("#single:")) {
                data.push({
                  value: custom_value.default_value,
                });

                custom_value.value = custom_value.default_value;
              } else {
                if (custom_value.default_value != null) {
                  data.push({ value: custom_value.default_value.split(";") });
                  custom_value.value = custom_value.default_value.split(";");
                } else {

                  data.push({ value: "" });
                  custom_value.value = "";
                }
              }
            } else {
              if (custom_value.default_value != null) {

                data.push({ value: custom_value.default_value });
                custom_value.value = custom_value.default_value;
              } else {

                data.push({ value: "" });
                custom_value.value = "";
              }
            }
          }
        }
        this.field_index[custom_value.fieldKey] = index;
        this.page_index[custom_value.fieldKey] = page_index;
      });
      this.field_values.push(data);
    });

    this.operations.forEach((operation) => {
      this.operations_values[operation.result] = {
        operand1: operation.operand1,
        operand2: operation.operand2,
        operator: operation.operator,
        type: operation.type,
        value: operation.type,
      };
      this.operations_index.push(operation.result);
    });

    this.buildFieldValueMaps();
  },

  mounted() {
    this.next_click = document.querySelectorAll(".next_button");
    this.main_form = document.querySelectorAll(".main");
    this.step_list = document.querySelectorAll(".progress_bar li");
    this.num = document.querySelector(".step-number");
    this.validate_inputs = [...document.querySelectorAll(".main.active input"), ...document.querySelectorAll(".main.active textarea")];

    this.next_click.forEach((next_click_form, index) => {
      if (index == 0) {
        next_click_form.addEventListener("click", () => {
          this.save(true);
        });
      } else {
        next_click_form.addEventListener("click", () => {
          this.save(false);
        });
      }
    });
    var back_click = document.querySelectorAll(".back_button");
    back_click.forEach((back_click_form) => {
      back_click_form.addEventListener("click", this.onBack);
    });
    var username = document.querySelector("#user_name");
    var shownname = document.querySelector(".shown_name");
    var submit_click = document.querySelectorAll(".submit_button");
    submit_click.forEach(function (submit_click_form) {
      submit_click_form.addEventListener("click", function () {
        shownname.innerHTML = username.value;
        this.formnumber++;
        this.updateform();
      });
    });
  },

  methods: {
    buildFieldValueMaps() {
      this.fieldValueMap.clear();
      this.testFieldValueMap.clear();

      if (!this.originalCustomValues) return;

      if (Array.isArray(this.originalCustomValues)) {
        this.originalCustomValues.forEach(field => {
          this.testFieldValueMap.set(field.fieldKey, field.value || '');
        });
      } else if (this.originalCustomValues.customValues) {
        this.originalCustomValues.customValues.forEach(field => {
          this.fieldValueMap.set(field.fieldKey, field.value || '');
        });
      }
    },

    replaceFieldKeysWithValues(text) {
      if (!text || typeof text !== 'string') return text;
      
      const valueMap = this.action === "test" ? this.testFieldValueMap : this.fieldValueMap;
      
      const pattern = new RegExp(
        Array.from(valueMap.keys())
          .map(key => this.escapeRegExp(key))
          .join('|'),
        'g'
      );

      return text.replace(pattern, match => valueMap.get(match) || '');
    },

    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },

    getPrefixValue(prefix){
      if (prefix && prefix.length > 0) {
        return prefix
      } else {
        return ""
      }
    },

    getSuffixValue(suffix){
      if (suffix && suffix.length > 0) {
        return suffix
      } else {
        return ""
      }
    },

    removePrefixSuffixValue(prefix, suffix, value) {
      if (typeof value !== "string") {
        return value
      }
      if (value.startsWith(prefix) && prefix!=null) {
        value = value.substr(prefix.length);
      }

      if (value.endsWith(suffix) && suffix!=null) {
        value = value.substr(0, value.length - suffix.length);
      }
      return value;
    },

    hasOperation(fieldKey, field_key){
      return this.operations_index.includes(fieldKey) || this.operations_index.includes(field_key);
    },

    showToolTip(_child) {
      let explanations = document.querySelectorAll(".SpeechBubble");

      let child = document.querySelector(_child);
      var scaleX = child.getBoundingClientRect().width / child.offsetWidth;
      if (scaleX == 0) {
        explanations.forEach(element => {
          element.style.animationName = "shrink";
          element.style.animationDuration = "0.1s";
        });

        child.style.animationName = "expand-bounce";
        child.style.animationDuration = "0.25s";
      } else {
        child.style.animationName = "shrink";
        child.style.animationDuration = "0.1s";
      }
    },

    hideToolTip(_child) {
      let child = document.querySelector(_child);
      child.style.animationName = "shrink";
      child.style.animationDuration = "0.1s";
    },

    ShowToolTip(name, description) {
      this.modalName = name;
      this.modalDescription = description;
      window.dialog.showModal();
    },

    HideToolTip() {
      this.modalName = "";
      this.modalDescription = "";
      window.dialog.close();
    },

    reorderPage() {
      this.pages.sort((a, b) => {
        if (a.position < b.position) {
          return -1;
        }
        if (a.position > b.position) {
          return 1;
        }

        return 0;
      });
    },

    showTab(index) {
      if (this.formnumber < index) {
        let current = this.formnumber;
        for (let i = 0; i < index - current; i++) {
          setTimeout(() => this.onNext(), 200);
        }
      } else if (this.formnumber > index) {
        let current = this.formnumber;
        for (let i = 0; i < current - index; i++) {
          setTimeout(() => this.onBack(), 200);
        }
      }
    },

    contentChange(change = false) {
      this.customValues = [];

      Object.values(this.pages[this.formnumber].custom_values).forEach(
        (custom_value, val_index) => {
          const operation = this.operations.find(
            ({ result }) => result === custom_value.fieldKey
          );

          if (operation == null) {
            this.customValues.push({
              id: custom_value.cv_id,
              fieldKey: custom_value.fieldKey,
              field_type: this.custom_value_type(custom_value.custom_field_type_id),
              name: custom_value.name,
              value:
                (typeof custom_value.value == "object"
                  ? this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, custom_value.value.join(";"))
                  : this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, custom_value.value.split('\n').join(' ')))+this.getSuffixValue(custom_value.suffix),
            });
          } else {
            this.customValues.push({
              id: custom_value.cv_id,
              fieldKey: custom_value.fieldKey,
              field_type: this.custom_value_type(custom_value.custom_field_type_id),
              name: custom_value.name,
              value: this.getPrefixValue(custom_value.prefix)+this.getOperationValue(operation)+this.getSuffixValue(custom_value.suffix),
            });
          }
        }
      );

      if (this.formnumber == this.pages.length - 1) {
        let customs = [];
        this.pages.forEach((page) => {
          customs.push(...Object.values(page.custom_values));
        });

        this.operations.forEach((operation) => {
          const result = customs.find(
            ({ fieldKey }) => fieldKey === operation.result
          );

          if (result == null) {
            this.customValues.push({
              id: this.getOperationId(operation.result),
              fieldKey: operation.result,
              field_type: '',
              name: this.getOperationName(operation.result),
              value: this.getOperationValue(operation),
            });
          }

        });


        this.$emit("save", this.action, this.customValues, this.formnumber, this.formnumber, true);
        return false;
      }

      if (change) {
        this.$emit("save", this.action, this.customValues, this.formnumber, this.formnumber + 1, change);
      } else {
        this.$emit("save", this.action, this.customValues, this.formnumber, this.formnumber + 1, false);
      }
    },

    save(change) {
      if (!this.validateform()) {
        return false;
      }
      this.contentChange(change);
    },

    onNext() {
      this.formnumber++;
      this.updateform();
      this.progress_forward();
    },
    onBack() {
      this.formnumber--;
      this.updateform();
      this.progress_backward();
    },
    updateform() {
      this.main_form.forEach(function (mainform_number) {
        mainform_number.classList.remove("active");
        mainform_number.classList.remove("slideDown");
      });
      this.main_form[this.formnumber].classList.add("slideDown");
      this.main_form[this.formnumber].classList.add("active");
    },
    progress_forward() {
      this.num.innerHTML = this.formnumber + 1;
      this.step_list[this.formnumber].classList.add("active");
    },
    progress_backward() {
      var form_num = this.formnumber + 1;
      this.step_list[form_num].classList.remove("active");
      this.num.innerHTML = form_num;
    },
    validateform() {
      let validate = true;
      this.validate_inputs = [...document.querySelectorAll(".main.active input"), ...document.querySelectorAll(".main.active select"), ...document.querySelectorAll(".main.active textarea")];
      this.validate_inputs.forEach(function (vaildate_input) {
        vaildate_input.classList?.remove("warning");
        if (vaildate_input.classList.value?.includes("require")) {
          if (vaildate_input.value.length == 0) {
            validate = false;
            vaildate_input.classList?.add("warning");
          }
        }
      });
      return validate;
    },


    compare(a, b) {
      if (a.custom_field_type_id < b.custom_field_type_id) {
        return -1;
      }
      if (a.custom_field_type_id > b.custom_field_type_id) {
        return 1;
      }
      return 0;
    },

    saveFile(file, custom) {

      this.filePreloader = true
      let data = new FormData();
      data.append("file", file);
      data.append("custom_id", custom.id);
      coreLibrary.methods.axiosPost({
        url: "/file/upload",
        data,
      }).then(({ data }) => {
        custom.value = data
        custom.hhh = data
      })
        .catch(({ response }) => {
          if (response.data && response.data.message) {
            this.$toastr.e(response.data.message);
            const errors = Object.values(response.data.data).map((el) => el[0]);
            this.$toastr.e(errors);
          }
        })
        .finally(() => {
          this.filePreloader = false

        });
    },

    reoderCustomValues(customValues) { },

    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },

    createBase64(event, custom) {
      let file = event.target.files ? event.target.files[0] : null;
      if (file) {
        const reader = new FileReader();
        reader.onload = (event) => {
          custom.value = event.target.result;
          custom.file_name = file.name;
        };
        reader.readAsDataURL(file);
      }
    },

    setCustomValue(value, custom) {
      if (
        this.custom_value_type(custom.custom_field_type_id) == "multi-select" ||
        this.custom_value_type(custom.custom_field_type_id) == "checkbox"
      ) {
        if (custom.choices.includes("#single:")) {
          custom.value = value;
        } else {
          custom.value = value.join(";");
        }
      } else {
        custom.value = this.removePrefixSuffixValue(custom.prefix, custom.suffix, value);
      }
    },

    getFieldOperationValue(operand1, operand2, operator, type) {
      let op2;
      let op1;

      var operand1_without_space = operand1.replace(/\s+/g, "");
      var operand2_without_space = operand2.replace(/\s+/g, "");

      if (this.field_index[operand1] !== undefined) {
        op1 =
          this.field_values[this.page_index[operand1]][
            this.field_index[operand1]
          ].value;
      } 
      else if (this.field_index[operand1_without_space] !== undefined) {
        op1 =
          this.field_values[this.page_index[operand1_without_space]][
            this.field_index[operand1_without_space]
          ].value;
      }
      else {
        op1 = this.findOperationValue(operand1);
      }

      if (this.field_index[operand2] !== undefined) {
        op2 =
          this.field_values[this.page_index[operand2]][
            this.field_index[operand2]
          ].value;
      } 
      else if (this.field_index[operand2_without_space] !== undefined) {
        op2 =
          this.field_values[this.page_index[operand2_without_space]][
            this.field_index[operand2_without_space]
          ].value;
      } 
      else {
        op2 = this.findOperationValue(operand2);
      }

      return this.makeOperation(type, operator, op1, op2);
    },

    makeOperation(type, operator, op1, op2) {
      if (type == "concat") {
        return op1 + "" + op2;
      } else if (type == "math") {
        op1 = parseFloat(op1);
        op2 = parseFloat(op2);

        if (isNaN(op1)) {
          op1 = 0;
        }
        if (isNaN(op2)) {
          op2 = 0;
        }

        if (operator == "addition") {
          return op1 + op2;
        } else if (operator == "substraction") {
          return op1 - op2;
        } else if (operator == "division") {
          return op1 / op2;
        } else if (operator == "multiplication") {
          return op1 * op2;
        }
      }
    },

    next(tab, n) {
      this.showTab(n);
    },

    custom_value_type(id) {
      let type = this.custom_field_types.filter(
        (el) => parseInt(el.id) === parseInt(id)
      );
      return type[0].name;
    },

    getOperationId(op) {
      let result;
      if (this.action == "test") {
        result = this.originalCustomValues.find(({ fieldKey }) => fieldKey === op);
      } else {
        result = this.originalCustomValues.customValues.find(
          ({ fieldKey }) => fieldKey === op
        );
      }
      return result.id;
    },

    getOperationName(op) {
      let result;
      if (this.action == "test") {
        result = this.originalCustomValues.find(({ fieldKey }) => fieldKey === op);
      } else {
        result = this.originalCustomValues.customValues.find(
          ({ fieldKey }) => fieldKey === op
        );
      }
      return result.name;
    },

    getOperationValue(operation) {
      let op1 = this.findOperationValue(operation.operand1);
      let op2 = this.findOperationValue(operation.operand2);

      return this.makeOperation(operation.type, operation.operator, op1, op2);
    },

    findOperationValue(op) {
      if (this.field_index[op] !== undefined) {
        let op1 =
          this.field_values[this.page_index[op]][
            this.field_index[op]
          ].value;
          return op1;
      }

      let value;
      const result = Object.values(this.pages[this.formnumber].custom_values).find(({ fieldKey }) => fieldKey === op);
      let result1;
      if (result == null) {
        if (this.action == "test") {
          result1 = this.originalCustomValues.find(({ fieldKey }) => fieldKey === op);
        } else {
          result1 = this.originalCustomValues.customValues.find(
            ({ fieldKey }) => fieldKey === op
          );
        }
        if (result1 == null) {
          value = op;
        } else {
          value = result1.value??'';
        }
      } else {
        value = result.value??'';
      }
      return value;
    },

  },
};
</script>
